import moment from 'moment';
import 'moment/locale/nl-be';

moment.locale('nl-be');

const convertDateTime = (dateToFormat) => {
  const dateValue = new Date(dateToFormat);
  let monthValue = dateValue.getMonth() + 1;
  let dayValue = dateValue.getDate();
  const yearValue = dateValue.getFullYear();
  let hoursValue = dateValue.getHours();
  let minutesValue = dateValue.getMinutes();
  let secondsValue = dateValue.getSeconds();

  if (monthValue < 10) { monthValue = `0${monthValue}`; }
  if (dayValue < 10) { dayValue = `0${dayValue}`; }
  if (hoursValue < 10) { hoursValue = `0${hoursValue}`; }
  if (minutesValue < 10) { minutesValue = `0${minutesValue}`; }
  if (secondsValue < 10) { secondsValue = `0${secondsValue}`; }

  // dd-mm-yyyy-hh-mm-ss
  return (`${dayValue}/${monthValue}/${yearValue} ${hoursValue}:${minutesValue}`);
};

const formatToLocalDate = (date) => {
  if (date == null) {
    return null;
  }

  const toUtc = moment.utc(date).toDate();
  return moment(toUtc).local().format('DD/MM/YYYY HH:mm');
};

const formatToLocalDateDay = (date) => {
  if (date == null) {
    return null;
  }

  const toUtc = moment.utc(date).toDate();
  return moment(toUtc).local().format('DD/MM/YYYY');
};

const formatToIsoDate = (date) => {
  if (date == null) {
    return null;
  }

  return moment(date, 'DD/MM/YYYY HH:mm').toISOString();
};

export {
  // eslint-disable-next-line import/prefer-default-export
  convertDateTime,
  formatToLocalDate,
  formatToLocalDateDay,
  formatToIsoDate,
};
